/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { motion, useReducedMotion } from "framer-motion";
import { ReactNode } from "react";

interface BounceAnimationWrapperProps {
  children: ReactNode;
  width?: "full" | "auto";
}

/**
 * Wraps a component and applies a "rubber band" bounce animation to it.
 */
export function BounceAnimationWrapper({
  children,
  width = "full",
}: BounceAnimationWrapperProps): JSX.Element {
  const prefersReducedMotion = useReducedMotion();

  if (prefersReducedMotion) {
    return <>{children}</>;
  }

  return (
    <motion.div
      css={css`
        ${width === "full"
          ? css`
              display: flex;
              justify-content: center;
              width: 100%;
            `
          : css`
              display: inline-block;
              width: fit-content;
            `}
      `}
      animate={{
        scaleX: [1, 1.06, 0.94, 1],
        scaleY: [1, 0.94, 1.06, 1],
      }}
      transition={{
        type: "spring",
        stiffness: 420,
        damping: 16,
        mass: 0.5,
        repeat: 3,
        repeatDelay: 2.4,
      }}
    >
      {children}
    </motion.div>
  );
}
